export const V004AsymmetricCiphertextPrefix = '004_Asym';
export const V004PartitionCharacter = ':';
